module.exports = __webpack_public_path__ + "img/logo.63a5f5c2.png";